import { render, staticRenderFns } from "./SortHotels.vue?vue&type=template&id=02812c03"
import script from "./SortHotels.vue?vue&type=script&lang=js"
export * from "./SortHotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Select: require('/vercel/path0/components/common/Select.vue').default,Card: require('/vercel/path0/components/common/Card.vue').default})
